import { ApplicationConfig, provideZoneChangeDetection } from "@angular/core";
import { provideRouter, withInMemoryScrolling } from "@angular/router";

import { routes } from "./app.routes";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { authInterceptor } from "./interceptors/auth.interceptor";
import { defaultHeadersInterceptor } from "./interceptors/default-headers.interceptor";
import { logoutInterceptor } from "./interceptors/logout.interceptor";
import { providePrimeNG } from "primeng/config";
import Aura from "@primeuix/themes/aura";
import { MessageService } from "primeng/api";

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(
            routes,
            withInMemoryScrolling({
                scrollPositionRestoration: "enabled",
            }),
        ),
        provideAnimationsAsync(),
        provideHttpClient(withInterceptors([defaultHeadersInterceptor, authInterceptor, logoutInterceptor])),
        providePrimeNG({
            theme: {
                preset: Aura,

                options: {
                    darkModeSelector: false || "none",
                    cssLayer: {
                        name: "primeng",
                        order: "theme, base, primeng",
                    },
                },
            },
        }),
        MessageService,
    ],
};
